(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yarin-about"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => { const button=event.target.closest('.yr3 .yr-prev, .yr3 .yr-next'); if(!button)return; const section=button.closest('.testimonial-section'); const slides=[...section.querySelectorAll('.testimonials-slide')]; if(!slides.length)return; let active=slides.findIndex(slide=>slide.style.display==='block'); if(active<0)active=0; active=(active+(button.classList.contains('yr-next')?1:-1)+slides.length)%slides.length; slides.forEach((slide,index)=>{slide.style.display=index===active?'block':'none'}); section.querySelector('.yr-review-count').textContent=String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0'); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yarin-home-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => { const button = event.target.closest('.yr3 .favorite-button'); if (!button) return; const liked = button.getAttribute('aria-pressed') !== 'true'; button.setAttribute('aria-pressed', String(liked)); button.classList.toggle('is-liked', liked); });

  } catch(e) { console.error(e); }
})();
})();
